import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import {formValueSelector} from "redux-form/immutable";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form, {prepareValuesForSubmission, validateForm} from "./PromoCodeForm";
import {cancelEditPromoCode} from "../../actions/SalesApiActions";
import {showDatePicker} from "../../actions/ViewActions";
import {fromJS} from "immutable";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {GET_PROMO_CODE} from "../panels/PromoCodePropertiesPanel";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";

class EditPromoCodeFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    const updatedValues = prepareValuesForSubmission(values);

    return this.props.changePromoCode(updatedValues.toJS())
      .then((response) => {
        if (response.data.changePromoCode.errors.length <= 0) {
          // Success
          this.handleCancel();
        } else {
          console.log(response.data.changePromoCode.errors)
          let errors = createValidationErrors(response.data.changePromoCode.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelEditPromoCode();
  }

  render() {
    const {loading, error, promoCode} = this.props.data;

    if (loading) return <Loading />;
    if (error) return <GraphQLErrors error={error} />;
    
    // Delete stuff we don't want to send in the mutation
    delete promoCode.createdAt;
    delete promoCode.__typename;
    delete promoCode.useCount;
    
    const initialValues = fromJS({
      ...promoCode,
      percentagex100: promoCode.percentage * 100,
      items: promoCode.items.map((i) => ({...i, selected: true})),
    });

    return (
      <Form
        {...this.props}
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        showDatePicker={this.props.showDatePicker}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        edit={true}
        />
    )
  }
}

const EDIT_PROMO_CODE = gql`
  mutation changePromoCode($data: ChangePromoCodeInput!) {
    changePromoCode(input: $data) {
      errors { key message }
    }
  }
`;


const withQuery = compose(
  graphql(GET_PROMO_CODE, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        code: props.code,
      },
    })
  }),
  graphql(EDIT_PROMO_CODE, {
    props: ({ mutate }) => ({
      changePromoCode: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

const EditPromoCodeFormContainerWithData = withQuery(EditPromoCodeFormContainer);

const selector = formValueSelector("PromoCodeForm");
function mapStateToProps(state, ownProps) {
  return {
    codeType: selector(state, "type"),
    codeJurisdiction: selector(state, "jurisdiction"),
    restrictionType: selector(state, "restrictionType"),
    expires: !!selector(state, "expires"), // Coerce to boolean
  }
}

export default connect(mapStateToProps, {cancelEditPromoCode, showDatePicker})(EditPromoCodeFormContainerWithData);